const SixAACPrescribedContent = `

Prescribed authority for the purposes of section 35CCB.

6AAC. For the purposes of section 35CCB, the “prescribed authority” shall be the Secretary, Department of Environment, Government of India

`;

export default SixAACPrescribedContent;